import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { ClipboardCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { useLang } from "@/i18n";

export default function PaperCardPanel({ card, setCard }) {
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  if (!card?.paper_card_printed_at) return null;
  const pending = !card.paper_card_processed;

  const toggle = async (v) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/repairs/${card.id}`, { paper_card_processed: v });
      setCard({ ...card, ...data });
      toast.success(v ? t("paperCardMarkedDone") : t("paperCardMarkedOpen"));
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };

  const fmt = (iso) => iso ? new Date(iso).toLocaleString(undefined, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "";
  return (
    <Card className={`p-4 border ${pending ? "border-primary/50 bg-primary/5" : "border-emerald-500/40 bg-emerald-500/5"}`} data-testid="paper-card-panel">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <ClipboardCheck className={`h-5 w-5 mt-0.5 ${pending ? "text-primary" : "text-emerald-500"}`} />
          <div>
            <div className="text-sm font-semibold">{pending ? t("paperCardPending") : t("paperCardDone")}</div>
            <div className="text-xs text-muted-foreground">
              {t("paperCardPrintedAt")}: {fmt(card.paper_card_printed_at)}
              {card.paper_card_processed_at ? ` · ${t("paperCardProcessedAt")}: ${fmt(card.paper_card_processed_at)}` : ""}
            </div>
            {pending && <div className="text-xs text-muted-foreground mt-1">{t("paperCardHint")}</div>}
          </div>
        </div>
        <label className="flex items-center gap-2 text-xs font-medium whitespace-nowrap">
          {t("paperCardProcessed")}
          <Switch checked={!pending} disabled={busy} onCheckedChange={toggle} data-testid="paper-card-processed-switch" />
        </label>
      </div>
    </Card>
  );
}
